import OrderSummaryViewController from './OrderSummaryViewController';

export default OrderSummaryViewController;
